import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { Sparkle } from '@phosphor-icons/react';

/**
 * SuggestionCard — bubble suggests, owner blesses. Agency not control.
 */
const SuggestionCard = ({ bubble, onUpdate }) => {
  const [sug, setSug] = useState(null);

  useEffect(() => {
    if (!bubble?.id) return;
    api.get(`/bubbles/${bubble.id}/suggestion`).then(({ data }) => setSug(data.suggestion));
  }, [bubble?.id]);

  const act = async (action) => {
    try {
      await api.post(`/bubbles/${bubble.id}/bless`, { action });
      toast.success(action === 'bless' ? 'Blessed.' : action === 'delay' ? 'Delayed.' : 'Stayed.');
      setSug(null);
      onUpdate && onUpdate();
    } catch (e) { toast.error(e?.response?.data?.detail || 'failed'); }
  };

  return (
    <AnimatePresence>
      {sug && !sug.blessed && (
        <motion.div initial={{ y: 12, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ opacity: 0 }}
          className="grad-border p-5" data-testid="suggestion-card">
          <div className="text-[10px] uppercase tracking-widest text-bx-volt flex items-center gap-1">
            <Sparkle size={12} weight="fill" /> {bubble.name} wants to say something
          </div>
          <p className="font-display text-lg italic mt-2">"{sug.text}"</p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button onClick={() => act('bless')} data-testid="bless-btn"
              className="btn-primary px-5 py-2.5 rounded-full text-sm font-bold">Bless it ✦</button>
            <button onClick={() => act('delay')} data-testid="delay-btn"
              className="px-5 py-2.5 rounded-full glass-hi text-sm font-bold hover:bg-white/10">Not yet</button>
            <button onClick={() => act('stay')} data-testid="stay-btn"
              className="px-5 py-2.5 rounded-full glass-hi text-sm font-bold hover:bg-white/10">Stay with me</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SuggestionCard;
